import { render } from "./business_info.vue?vue&type=template&id=3859a152&scoped=true"
import script from "./business_info.vue?vue&type=script&lang=js"
export * from "./business_info.vue?vue&type=script&lang=js"

import "./business_info.vue?vue&type=style&index=0&id=3859a152&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3859a152"]])

export default __exports__